module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"close":"Close"},"fr":{"close":"Fermer"}}')
  delete Component.options._Ctor
}
